module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['op--modal-container', {
      hide: !_vm.show
    }],
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "more-images-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "service-label"
  }, [_vm._v(_vm._s(_vm.moreImg.service))]), _vm._v(" "), _c('div', {
    staticClass: "img-box"
  }, [_c('i', {
    class: ['fa fa-chevron-left fa-fw fa-2x', {
      disabled: _vm.currentImgIndex === 0
    }],
    on: {
      "click": _vm.prev
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('img', {
    key: _vm.img,
    attrs: {
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('i', {
    class: ['fa fa-chevron-right fa-fw fa-2x', {
      disabled: _vm.currentImgIndex === _vm.imgs.length - 1
    }],
    on: {
      "click": _vm.next
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-a-m"
  }, [_c('span', {
    staticClass: "op-btn btn-md btn-block",
    on: {
      "click": _vm.close
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.close')))])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4fcc7404", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fcc7404","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceSelection/MoreImages.vue
// module id = 2092
// module chunks = 0